export const LETTERS = /[a-z]+/gi; 
export const LOWER_CASE_LETTERS = /[a-z]+/;
export const UPPER_CASE_LETTERS = /[A-Z]+/;
export const NUMBERS = /\d+/gi;
export const ONLY_NUMBERS = /^\d+$/;
export const NOT_NUMBERS = /\D/gi;
export const SPECIAL_SYMBOLS = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
export const EMAIL = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
